import { useMemo, useState } from "react";

interface ExportData {
  page: string;
  download_url: string;
  download_size_bytes: number;
}

export const usePagination = (itemList: any[], maxItemsPerPage: number = 10) => {
  const [currentPage, setCurrentPage] = useState(1);

  const isPaginating = itemList.length > maxItemsPerPage;
  const totalPages = Math.ceil(itemList.length / maxItemsPerPage);

  const pageItems: ExportData[] = useMemo(() => {
    const begin = (currentPage - 1) * maxItemsPerPage;
    const end = begin + maxItemsPerPage;
    return itemList.slice(begin, end);
  }, [itemList, currentPage, maxItemsPerPage]);

  return {
    isPaginating,
    currentPage,
    setCurrentPage,
    pageItems,
    totalPages,
  };
};
